/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function Plus({
    className = null,
}: Props) {
    return (
        <svg className={className} width="12" height="13" viewBox="0 0 12 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_496_3362)">
                <path d="M11.3333 5.83333H6.66667V1.16667C6.66667 0.989856 6.59643 0.820286 6.4714 0.695262C6.34638 0.570238 6.17681 0.5 6 0.5C5.82319 0.5 5.65362 0.570238 5.5286 0.695262C5.40357 0.820286 5.33333 0.989856 5.33333 1.16667V5.83333H0.666667C0.489856 5.83333 0.320286 5.90357 0.195262 6.0286C0.0702379 6.15362 0 6.32319 0 6.5C0 6.67681 0.0702379 6.84638 0.195262 6.9714C0.320286 7.09643 0.489856 7.16667 0.666667 7.16667H5.33333V11.8333C5.33333 12.0101 5.40357 12.1797 5.5286 12.3047C5.65362 12.4298 5.82319 12.5 6 12.5C6.17681 12.5 6.34638 12.4298 6.4714 12.3047C6.59643 12.1797 6.66667 12.0101 6.66667 11.8333V7.16667H11.3333C11.5101 7.16667 11.6797 7.09643 11.8047 6.9714C11.9298 6.84638 12 6.67681 12 6.5C12 6.32319 11.9298 6.15362 11.8047 6.0286C11.6797 5.90357 11.5101 5.83333 11.3333 5.83333Z" />
            </g>
            <defs>
                <clipPath id="clip0_496_3362">
                    <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
